import { requestJson, requestMultipart } from "@/lib/api";
import type { DeliveryConfirmation } from "@/lib/types";

export interface DriverOrder {
  id: string;
  clientName: string;
  deliveryWindow?: string | null;
  deliveryDate?: string | null;
  routeStartedAt?: string | null;
  notes?: string | null;
  /** NF da conferência de expedição; quando presente, a entrega reutiliza/trava esta NF. */
  conferenceNf?: string | null;
}

export async function fetchDriverOrders(date?: string): Promise<DriverOrder[]> {
  const qs = date ? `?date=${encodeURIComponent(date)}` : "";
  return requestJson<DriverOrder[]>(`/api/v1/driver/orders${qs}`);
}

export interface DeliveredOrder {
  orderId: string;
  clientName: string;
  nfNumber: string;
  driverName: string;
  deliveredAt: string;
  truckTemperature: number;
  receiverName: string;
  receiverDocument: string;
  signatureUrl: string;
  receiptPhotoUrl: string;
}

export async function fetchDeliveredOrders(date?: string): Promise<DeliveredOrder[]> {
  const qs = date ? `?date=${encodeURIComponent(date)}` : "";
  return requestJson<DeliveredOrder[]>(`/api/v1/driver/orders/delivered${qs}`);
}

export interface ConfirmDeliveryInput {
  orderId: string;
  nfNumber: string;
  driverName: string;
  deliveredAt: string; // ISO
  truckTemperature: string;
  receiverName: string;
  receiverDocument: string;
  signature: Blob;
  receiptPhoto: File;
}

export async function confirmDelivery(input: ConfirmDeliveryInput): Promise<DeliveryConfirmation> {
  const fd = new FormData();
  fd.append("nfNumber", input.nfNumber);
  fd.append("driverName", input.driverName);
  fd.append("deliveredAt", input.deliveredAt);
  fd.append("truckTemperature", input.truckTemperature);
  fd.append("receiverName", input.receiverName);
  fd.append("receiverDocument", input.receiverDocument);
  fd.append("signature", input.signature, "signature.png");
  fd.append("receiptPhoto", input.receiptPhoto, input.receiptPhoto.name || "receipt.jpg");
  return requestMultipart<DeliveryConfirmation>(
    `/api/v1/driver/orders/${input.orderId}/confirm-delivery`,
    fd,
  );
}
